var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clickable)?_c('router-link',{directives:[{name:"tippy",rawName:"v-tippy"}],class:_vm.className,attrs:{"title":_vm.title,"to":_vm.object.url()},nativeOn:{"contextmenu":function($event){return _vm.handleRightClick($event)}}},[_vm._t("default")],2):_c('div',{directives:[{name:"tippy",rawName:"v-tippy"}],class:[_vm.className, 'current'],attrs:{"title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e7bdc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObjectImageWrapper.vue
// module id = 76
// module chunks = 0